export default __webpack_public_path__ + "static/media/homeLogo.07ec02e4.svg";